"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const TextInput_1 = __importDefault(require("./TextInput"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const TimeInput = (props) => (react_1.default.createElement(TextInput_1.default, Object.assign({ type: "time" }, props)));
exports.default = withJourney_1.default('j-time-input', TimeInput);
